/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import AgreementCopy from 'material/agreementcopy/aggreementcopy';
import { Page, Group, Copy, BodyCopy, CTAs, Button } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'pages/auth/acceptagreement/acceptagreement_styles';


/* ========== ~~~~~~~~~~ AUTH Accept Agreement COMPLETE ~~~~~~~~~~ ========== */


export default injectSheet(styles)((props) => {
        const signAgreement = () => {
            const { userUUID, agreementUUID } = props;
            props.updateAgreementInfo(agreementUUID, userUUID, onSignedAgreement);
        };

        const onSignedAgreement = ({success}) => {
            if (success) props.moveToPage('');
        };

        return (
            <Page name={`acceptagreement`} klass={props.classes.acceptagreement}>
                <Group name={`main`}>
                    <Copy>
                        <BodyCopy>
                            <h1>Please accept our Publisher Agreement.</h1>
                            <AgreementCopy clickDescription={'Agree to Publisher Agreement'}/>
                            <CTAs>
                                <Button
                                    disabled={!props.agreementUUID}
                                    variant={'primary'}
                                    type={'action'}
                                    action={signAgreement}
                                    text={'Agree to Publisher Agreement'}/>
                            </CTAs>
                        </BodyCopy>
                    </Copy>
                </Group>
            </Page>
        )
    }
)
